import React from 'react';
import { Box, Typography } from '@mui/material';
import SincronizacaoTable from '../components/sincronizacao/SincronizacaoTable';

const Sincronizacoes: React.FC = () => {
  return (
    <Box>
      <Typography 
        variant="h4" 
        component="h1" 
        gutterBottom 
        sx={{ 
          fontWeight: 'bold',
          fontFamily: 'Arial, sans-serif',
          fontSize: '2.125rem',
          lineHeight: 1.235
        }}
      >
        Consulta de Sincronizações
      </Typography>
      <SincronizacaoTable />
    </Box>
  );
};

export default Sincronizacoes;
